export default "__VITE_ASSET___RsTgn5J__"